/* Przegladarka katalogu: klikniecie w okladke otwiera pelnoekranowy podglad
   z rozkladowkami. Strony to obrazy WebP z Shopify Files, ladowane leniwie -
   otwarcie sciaga jedna strone (~130 kB), a nie caly PDF (13,5 MB). */
if (!customElements.get('catalog-viewer')) {
  class CatalogViewer extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('script[data-catalog-pages]');
      try {
        this.pages = JSON.parse(data ? data.textContent : '[]');
      } catch (e) {
        this.pages = [];
      }
      if (!this.pages.length) return;

      const hs = this.querySelector('script[data-catalog-hotspots]');
      try {
        this.hotspots = hs ? JSON.parse(hs.textContent) : [];
      } catch (e) {
        this.hotspots = [];
      }

      this.index = 0;
      this.zoomed = false;
      this.overlay = null;
      this.lastFocus = null;

      /* Strony 2-42 to rozkladowki (dwie strony A4 obok siebie), okladki sa
         pojedyncze. Na telefonie rozkladowka daje 195 px na strone, czyli tekst
         nieczytelny - dlatego na wąskim ekranie pokazujemy po jednej połowie. */
      this.narrow = window.matchMedia('(max-width: 767px)');
      this.buildViews();
      this.onBreakpoint = () => {
        const page = this.views[this.index] ? this.views[this.index].page : 0;
        this.buildViews();
        this.index = this.views.findIndex((v) => v.page === page);
        if (this.index < 0) this.index = 0;
        if (this.overlay) this.render();
      };
      this.narrow.addEventListener('change', this.onBreakpoint);

      this.querySelectorAll('[data-catalog-open]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(Number(el.dataset.catalogOpen) || 0);
        });
      });
    }

    /* Widok = to, co pokazujemy naraz. Na szerokim ekranie jeden widok na
       obrazek; na wąskim rozkladowka rozbija sie na lewa i prawa polowe. */
    buildViews() {
      const split = this.narrow.matches;
      this.views = [];
      this.pages.forEach((page, i) => {
        const isSpread = page.w && page.h && page.w > page.h;
        if (split && isSpread) {
          this.views.push({ page: i, half: 'left' });
          this.views.push({ page: i, half: 'right' });
        } else {
          this.views.push({ page: i, half: null });
        }
      });
    }

    /* ---------- otwieranie i zamykanie ---------- */

    open(index) {
      if (this.overlay) return;
      this.lastFocus = document.activeElement;
      this.index = Math.min(Math.max(index, 0), this.views.length - 1);
      this.overlay = this.buildOverlay();
      document.body.appendChild(this.overlay);
      this.scrollY = window.scrollY;
      document.body.classList.add('catalog-viewer-open');
      this.render();
      requestAnimationFrame(() => {
        this.overlay.classList.add('is-visible');
        this.overlay.querySelector('[data-close]').focus();
      });
      this.onKey = (event) => this.handleKey(event);
      document.addEventListener('keydown', this.onKey);
      this.onResize = () => this.fit();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.narrow && this.onBreakpoint) this.narrow.removeEventListener('change', this.onBreakpoint);
    }

    close() {
      if (!this.overlay) return;
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('catalog-viewer-open');
      this.overlay.remove();
      this.overlay = null;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    handleKey(event) {
      if (event.key === 'Escape') this.close();
      else if (event.key === 'ArrowRight' || event.key === 'PageDown') this.go(1);
      else if (event.key === 'ArrowLeft' || event.key === 'PageUp') this.go(-1);
      else if (event.key === 'Home') this.jump(0);
      else if (event.key === 'End') this.jump(this.views.length - 1);
    }

    /* ---------- nawigacja ---------- */

    go(delta) { this.jump(this.index + delta); }

    jump(index) {
      const next = Math.min(Math.max(index, 0), this.views.length - 1);
      if (next === this.index) return;
      this.index = next;
      this.zoomed = false;
      this.render();
    }

    /* ---------- widok ---------- */

    buildOverlay() {
      const t = this.dataset;
      const el = document.createElement('div');
      el.className = 'catalog-viewer';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', t.labelTitle || 'Katalog');
      el.innerHTML = [
        '<div class="catalog-viewer__bar">',
        '  <span class="catalog-viewer__title"></span>',
        '  <span class="catalog-viewer__counter" data-counter aria-live="polite"></span>',
        '  <span class="catalog-viewer__tools">',
        t.pdfUrl
          ? '    <a class="catalog-viewer__btn catalog-viewer__btn--text" data-download href="' +
            t.pdfUrl + '" download>' + (t.labelDownload || 'Pobierz PDF') + '</a>'
          : '',
        '    <button class="catalog-viewer__btn" type="button" data-close aria-label="' +
          (t.labelClose || 'Zamknij') + '">&#215;</button>',
        '  </span>',
        '</div>',
        '<div class="catalog-viewer__stage" data-stage>',
        '  <div class="catalog-viewer__scroll" data-scroll>',
        '    <div class="catalog-viewer__frame" data-frame>',
        '      <img class="catalog-viewer__page" data-page alt="">',
        '      <div class="catalog-viewer__spots" data-spots></div>',
        '    </div>',
        '  </div>',
        '</div>',
        '<div class="catalog-viewer__shelf" data-shelf hidden></div>',
        '<button class="catalog-viewer__nav catalog-viewer__nav--prev" type="button" data-prev aria-label="' +
          (t.labelPrev || 'Poprzednia strona') + '"></button>',
        '<button class="catalog-viewer__nav catalog-viewer__nav--next" type="button" data-next aria-label="' +
          (t.labelNext || 'Nastepna strona') + '"></button>',
      ].join('');

      el.querySelector('.catalog-viewer__title').textContent = t.labelTitle || '';
      el.querySelector('[data-close]').addEventListener('click', () => this.close());
      el.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
      el.querySelector('[data-next]').addEventListener('click', () => this.go(1));
      el.addEventListener('click', (event) => { if (event.target === el) this.close(); });

      const img = el.querySelector('[data-page]');
      img.addEventListener('click', () => this.toggleZoom());

      /* przesuwanie palcem */
      let x0 = null;
      const stage = el.querySelector('[data-stage]');
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null || this.zoomed) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) this.go(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });

      return el;
    }

    toggleZoom() {
      if (!this.overlay) return;
      this.zoomed = !this.zoomed;
      const scroll = this.overlay.querySelector('[data-scroll]');
      scroll.classList.toggle('is-zoomed', this.zoomed);
      this.fit();
      if (this.zoomed) {
        scroll.scrollLeft = (scroll.scrollWidth - scroll.clientWidth) / 2;
        scroll.scrollTop = (scroll.scrollHeight - scroll.clientHeight) / 2;
      }
    }

    render() {
      if (!this.overlay) return;
      const view = this.views[this.index];
      const page = this.pages[view.page];
      const img = this.overlay.querySelector('[data-page]');
      const frame = this.overlay.querySelector('[data-frame]');

      img.src = page.src;
      if (page.srcset) img.srcset = page.srcset;
      /* Polowka zajmuje cala szerokosc ekranu, wiec obrazek musi byc dwa razy
         szerszy niz viewport - inaczej przegladarka wzielaby za maly wariant. */
      img.sizes = view.half ? '200vw' : '100vw';
      img.width = view.half ? Math.round((page.w || 0) / 2) : page.w || 0;
      img.height = page.h || 0;
      img.alt = (this.dataset.labelPage || 'Strona') + ' ' + (this.index + 1);

      frame.classList.toggle('is-half', !!view.half);
      frame.classList.toggle('is-half--right', view.half === 'right');
      if (view.half && page.w && page.h) {
        frame.style.setProperty('--half-ratio', (page.w / 2) + ' / ' + page.h);
      } else {
        frame.style.removeProperty('--half-ratio');
      }

      this.overlay.querySelector('[data-scroll]').classList.remove('is-zoomed');
      this.overlay.querySelector('[data-counter]').textContent =
        (this.index + 1) + ' / ' + this.views.length;
      this.overlay.querySelector('[data-prev]').disabled = this.index === 0;
      this.overlay.querySelector('[data-next]').disabled = this.index === this.views.length - 1;
      this.renderSpots();
      this.fit();
      this.preload(this.index + 1);
      this.preload(this.index - 1);
    }

    /* Wpisuje ramce konkretne piksele tak, zeby cala strona zmiescila sie
       w scenie bez deformacji - odpowiednik object-fit: contain, ktorego
       samym CSS-em nie da sie tu uzyskac (patrz komentarz w catalog-viewer.css).
       Proporcje bierzemy z metadanych strony, nie z naturalWidth, bo fit()
       biegnie takze zanim obrazek sie sciagnie. */
    fit() {
      if (!this.overlay) return;
      const scroll = this.overlay.querySelector('[data-scroll]');
      const frame = this.overlay.querySelector('[data-frame]');
      const view = this.views[this.index];
      const page = view ? this.pages[view.page] : null;
      if (!page || !page.w || !page.h) return;

      const ratio = (view.half ? page.w / 2 : page.w) / page.h;
      const availW = scroll.clientWidth;
      const availH = scroll.clientHeight;
      if (!availW || !availH) return;

      let w = availW;
      let h = w / ratio;
      if (h > availH) {
        h = availH;
        w = h * ratio;
      }
      const scale = this.zoomed ? 2.2 : 1;
      frame.style.width = w * scale + 'px';
      frame.style.height = h * scale + 'px';
    }

    /* Punkty klikalne siedza na podpisach produktow - wspolrzedne pochodza
       z tekstu w PDF, wiec trafiaja dokladnie. Pod strona jest listwa z lista
       produktow z tej rozkladowki, bo na telefonie male punkty sa nieuzywalne. */
    renderSpots() {
      const spots = this.overlay.querySelector('[data-spots]');
      const shelf = this.overlay.querySelector('[data-shelf]');
      const view = this.views[this.index];
      const pageNo = view.page + 1;
      /* Warstwa punktow jest na wąskim ekranie dwa razy szersza od ramki
         i przesunieta razem z obrazkiem, wiec wspolrzedne zostaja te same. */
      const list = this.hotspots.filter((h) => h.page === pageNo);
      const visible = view.half
        ? list.filter((h) => (view.half === 'left' ? h.x < 0.5 : h.x >= 0.5))
        : list;

      spots.innerHTML = '';
      list.forEach((h) => {
        const a = document.createElement('a');
        a.className = 'catalog-viewer__spot';
        a.href = h.url;
        a.title = h.title;
        a.setAttribute('aria-label', h.title);
        a.style.left = (h.x * 100) + '%';
        a.style.top = (h.y * 100) + '%';
        a.style.width = (h.w * 100) + '%';
        a.style.height = (h.h * 100) + '%';
        /* Punkty z niewidocznej polowy sa przyciete overflow, ale bez tego
           lapialyby focus przy tabowaniu. */
        if (view.half && visible.indexOf(h) === -1) {
          a.tabIndex = -1;
          a.setAttribute('aria-hidden', 'true');
        }
        spots.appendChild(a);
      });

      if (!visible.length) {
        shelf.hidden = true;
        shelf.innerHTML = '';
        return;
      }
      const seen = new Set();
      const unique = visible.filter((h) => (seen.has(h.handle) ? false : seen.add(h.handle)));
      shelf.hidden = false;
      shelf.innerHTML =
        '<span class="catalog-viewer__shelf-label">' +
        (this.dataset.labelOnPage || 'Produkty z tej rozkladowki') + '</span>' +
        unique
          .map((h) => '<a class="catalog-viewer__shelf-item" href="' + h.url + '">' + h.title + '</a>')
          .join('');
    }

    preload(index) {
      const view = this.views[index];
      const page = view ? this.pages[view.page] : null;
      if (!page) return;
      const img = new Image();
      if (page.srcset) img.srcset = page.srcset;
      img.src = page.src;
    }
  }
  customElements.define('catalog-viewer', CatalogViewer);
}
